export default __webpack_public_path__ + "static/media/Homepageintro.3e1f6eab.svg";